import * as React from "react";
import { observer } from "mobx-react-lite";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { NGSwitch } from "../../../../newcomponents/switch";
import { NGLabelText } from "../../../../newcomponents/text/labelText";
import { DryRunAlert } from "../../dryRunAlert";
import { mk8sDryRun } from "../../../../mobxStores/dryRun/mk8s";

interface Props {
  mk8sDraft: Mk8sDraftMobx;
}
const CreateAddonsNvidiaRaw: React.FC<Props> = ({ mk8sDraft }) => {
  return (
    <div>
      <div className="mb-4">
        <DryRunAlert
          key={mk8sDryRun.key}
          canShow={true}
          dryRunResponse={mk8sDryRun.response}
          path={"spec.addOns.nvidia"}
          paths={["spec.addOns.nvidia.taintGPUNodes"]}
        />
      </div>
      <div className="mb-2">Nvidia</div>
      <NGSwitch
        value={mk8sDraft.addon_nvidia.taintGPUNodes}
        onChange={(value) => mk8sDraft.addon_nvidia.setTaintGPUNodes(value)}
      >
        <NGLabelText>Taint GPU Nodes</NGLabelText>
      </NGSwitch>
    </div>
  );
};

export const CreateAddonsNvidia = observer(CreateAddonsNvidiaRaw);
